<template>
    <div class="pathScreen">
        <div class="path">
            <pathSvg ref="svgPath"></pathSvg>
            <!--<div class="plane" style="" ref="testPlane"></div>-->
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap';
    import pathSvg from '@/assets/svg/path-ap.svg';
    import PathMover from "./PathMover/PathMover";

    export default {
        name: 'path2',
        data() {
            return {
                pathMover: null,
            }
        },
        components: {
            pathSvg
        },
        methods: {
            createPathMover() {
                const SVG = this.$refs['svgPath'].$el;
                //this.pathMover = new PathMover(SVG);
            }
        },
        mounted() {
            this.createPathMover();
        }
    }
</script>


// WEBPACK FOOTER //
// pathAirPlane.vue?10d07532